import API from "@utils/request";

const COMMON = "/common/";

let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
  prout = 'protal';
} else {
  prout = 'protal_' + Language;
}




/**
 * 文件上传
 * @param {file} file
 */
export async function uploadFile(file) {
  try {
    const formData = new FormData();
    formData.append("file", file, file.name);

    return await API.post(COMMON + "/uploadfile", formData, {
      transformRequest: [
        function (data) {
          return data;
        },
      ],
    });
  } catch (error) {
    return error;
  }
}


/**
 * 获取阿里云OSS STS相关值
 * @returns 
 */
export async function getaliyunoss() {
  try {
    return await API.post("/api/tool/getAliyunOssSts");
  } catch (error) {
    return error;
  }
}


export async function addAttachment(params) {
  try {
    return await API.post("/api/tool/addAttachment", params);
  } catch (error) {
    return error;
  }
}

// export async function addAttachment() {
//   try {
//     return await API.post("/api/tool/addAttachment", params);
//   } catch (error) {
//     return error;
//   }
// }


// 个人信息弹框

export async function getuserDetail(params) {
  try {
    return await API.post("/api/" + prout + "/user/userDetail", params);
  } catch (error) {
    return error;
  }
}

// 站内信 frontMsgList

export async function getfrontMsgList(params) {
  try {
    return await API.post("/api/" + prout + "/api/index/frontMsgList", params);
  } catch (error) {
    return error;
  }
}
// 判断是否登录

export async function getLoginInfo(params) {
  try {
    return await API.post("/api/" + prout + "/api/index/getLoginInfo", params);
  } catch (error) {
    return error;
  }
}


/** 导出-get */
// export async function 方法名(params) {
//   try {
//     return await API.get("接口名称",{
//       params,
//       responseType: "blob",
//     });
//   } catch (error) {
//     return error;
//   }
// }

/** 导出-post */
// export async function 方法名(params) {
//   try {
//     return await API.post("接口名称", params, {
//       responseType: "blob",
//     });
//   } catch (error) {
//     return error;
//   }
// }
